import DefaultLayout from '##/Default';
import Comp from './List';


const routes = [
    {
        path: '/scripts/:page?',
        exact: true,
        layout: DefaultLayout,
        component: Comp,
        auth: true,
        title: 'Scripts'
    }
];

export default routes;
